/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type TransactionCell_transaction$ref: FragmentReference;
declare export opaque type TransactionCell_transaction$fragmentType: TransactionCell_transaction$ref;
export type TransactionCell_transaction = {|
  +id: string,
  +name: ?string,
  +storeName: ?string,
  +date: ?string,
  +location: ?string,
  +merchantName: ?string,
  +amount: ?number,
  +state: ?string,
  +status: ?string,
  +cashbackRate: ?string,
  +cashbackId: ?string,
  +$refType: TransactionCell_transaction$ref,
|};
export type TransactionCell_transaction$data = TransactionCell_transaction;
export type TransactionCell_transaction$key = {
  +$data?: TransactionCell_transaction$data,
  +$fragmentRefs: TransactionCell_transaction$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TransactionCell_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "storeName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "merchantName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cashbackRate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cashbackId",
      "storageKey": null
    }
  ],
  "type": "PlaidTransaction"
};
// prettier-ignore
(node/*: any*/).hash = 'c68d44f65906ce5e0e391f73bb039b6d';

module.exports = node;
